export default __webpack_public_path__ + "static/media/baseline-battery_charging_30-24px.f89e4858.svg";